"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uuid = require("uuid");

var _Google = require("../Google");

var _Kochava = require("../Kochava");

var _Sift = require("../Sift");

var _Fingerprint = require("../Fingerprint");

var _TreasureData = require("../TreasureData");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }

var AnalyticsProvider = function AnalyticsProvider(_a) {
  var children = _a.children,
      settings = _a.settings;
  var uuid = (0, _react.useMemo)(function () {
    return (0, _uuid.v1)();
  }, []);
  (0, _react.useEffect)(function () {
    sessionStorage.setItem('session_id', (0, _uuid.v1)());
  }, [uuid]);
  return settings ? _react["default"].createElement(_Sift.SiftProvider, {
    sessionId: uuid,
    settings: settings,
    sift: settings.CONFIG.SIFT
  }, _react["default"].createElement(_Google.GoogleProvider, {
    gtm: settings.CONFIG.GOOGLE_TAG_MANAGER,
    settings: settings
  }, _react["default"].createElement(_Fingerprint.FingerprintProvider, {
    settings: settings
  }, _react["default"].createElement(_Kochava.KochavaProvider, {
    kochava: settings.CONFIG.KOCHAVA,
    settings: settings
  }, _react["default"].createElement(_TreasureData.TreasureDataProvider, {
    settings: settings,
    treasureData: settings.CONFIG.TREASURE_DATA
  }, children))))) : _react["default"].createElement(_react["default"].Fragment, null, children);
};

var _default = AnalyticsProvider;
exports["default"] = _default;